// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"linkContainer--LlrNg","linkText":"linkText--YrP6+"};